<template>
    <div>
        <h1>Moderaattorina Karanteenissa</h1>
        <p>
            Moderaattorien tehtäviin pähkinänkuoressa kuuluu: 
            <ul>
                <li>Alueiden suojaaminen</li>
                <li>Tarkistaa mahdolliset griefit ja delegoida operator / admin</li>
                <li>Warnata pelaajia sääntörikkeistä (lähinnä chat + npc peltogrief)</li>
                <li>Bannia pelaajia sääntörikkeistä (lähinnä pienemmän skaalan jutut)</li>
            </ul>
        </p>
        <p>Moderaattorina avautuu älyttömän paljon tavaraa, joka mahdollistaa moderointia näppärästi.</p>
        <p>Moderaattoreilla on vastuu olla käyttämättä komentojaan ns "admin abuseen".</p>
        <h2>
            Täysi lista moderaattorina aukeavista komennoista
        </h2>

        <h3>Yleiset</h3>
        <div class="command-list">
            <Command command="" params="" desc="Kaikki Kuolemattoman, ja alempien rankkien komennot" />
            <Command command="dynmap" params="hide" desc="piilottaa sinut dynmapista, suositellaan pitämään päällä ylläpitäjänä."/>
            <Command command="dynmap" params="show" desc="palauttaa pelaajan takaisin dynmappiin"/>
            <Command command="yp" params="teksti" desc="Tämä on siis ypchat. Ylläpidon väliseen chättäilyyn" example="Esim. /yp moi Susse miten menee!!!!" />
            <Command command="warp" params="nimi pelaaja" desc="Lähettää pelaajan warppiin" />
            <Command command="spawn" params="pelaaja" desc="Lähettää pelaajan spawnille" />
            <Command command="homes" params="pelaaja" desc="Näyttää pelaajan kodit" />
            <Command command="home" params="pelaaja koti" desc="Käytä toisen pelaajan koteja" />
            <Command command="tp" params="lähetettävä_pelaaja pelaaja" desc="Lähetä pelaaja toisen luokse" />
            <Command command="nick" params="pelaaja nick" desc="kyky laittaa pelaajille nick" />
            <Command command="speed" params="walk/fly (-5)-5" desc="Muuta lento / kävelynopeuttasi" example="Esim. /speed fly 3" />
            <Command command="setsign" params="rivi_numero teksti" desc="Kylttien muokkaus asettamisen jälkeen" />
        </div>
        <h3>Suojaaminen</h3>
        <div class="command-list">
            <Command command="alue" params="" desc="Näyttää alueen, jolla seisot. Käytetään kun tarkastetaan, onko alue jo jonkun suojauksessa." />
            <Command command="/pos1" params="" desc="(alueen valitsemiseen) Valitse alueen ensimmäinen nurkka " />
            <Command command="/pos2" params="" desc="(alueen valitsemiseen) Valitse alueen toinen nurkka " />
            <Command command="/expand" params="vert" desc="Laajenna valitun alueen korkeudeksi koko korkeus bedrockista taivaaseen." />
            <Command command="rg" params="define alueen_nimi pelaajan_nimi" desc="Luo valitulle alueelle suojauksen, jonka omistaja on pelaajan_nimi. Omistajia voi olla useita, jos nimet erottelee välilyönnillä." example="Esim komennolla '/rg define susse_1 Susse' luodaan valittuun alueeseen suojaus jonka nimi on susse_1 ja omistaja Susse" />
            <Command command="rg" params="redefine alueen_nimi" desc="Muuttaa alueen rajat uuteen valintaan" />
            <Command command="wesv" params="toggle" desc="Näyttää world edit valinnan rajat" />
        </div>
        <h3>Grieffien tarkastaminen</h3>
        <div class="command-list">
            <Command command="co" params="i" desc="Vaihtaa palikoiden tarkasteluun päälle. Kun lyöt palikoita, näet mitä niile on tehty. Tai kun right clickkaat arkkua, näet mitä sieltä on viety" />
            <Command command="co" params="l" desc="Core Lookup. Syvempään tarkasteluun. (Kehittyneeseen käyttöön ks. coreprotect-opas)" example="Esim katso pelaaja Susse tappanut mobeja 50 block säteellä viimeisen 14 päivän aikana. /co l u:Susse a:kill r:50 t:14"/>
        </div>
        <h3>Pelaajien tarkkailu</h3>
        <div class="command-list">
            <Command command="openinv" params="pelaaja" desc="katsele pelaajan inventoryyn" />
            <Command command="openender" params="pelaaja" desc="katsele pelaajan enderchestiin" />
            <Command command="socialspy" params="" desc="Laittaa päälle pelaajien yksityisviestien logaamisen." />
            <Command command="sv" params="" desc="Togglee vanishin. Olet näkymätön palvelimella." example="Huom. Todennäköisesti tämän sijasta haluat käyttää /gmsp" />
            <Command command="gms" params="" desc="(gamemode survival) laittaa käyttöön survivalmoden" />
            <Command command="gmsp" params="" desc="(gamemode spectator) laittaa käyttöön spectatormoden. Lennät näkymättömänä." />
        </div>
        <h3>Muu moderointi</h3>
          <div class="command-list">
            <Command command="alts" params="pelaaja" desc="Palauttaa listan pelaajan alteista"/>
            <Command command="kick" params="pelaaja syy" desc="Potkii pelaajan palvelimelta" />
            <Command command="ban" params="pelaaja aika syy" desc="Bannii pelaajan asetetuksi ajaksi" example="esim /ban Susse 14d Jatkuva huono käyttäytyminen" />
            <Command command="banlist" params="sivunro" desc="näyttää ban listat (bans.karanteeni.net on parempi työkalu)" />
            <Command command="checkban" params="pelaaja" desc="Kertoo onko pelaaja bännätty" />
            <Command command="warn" params="pelaaja syy" desc="Antaa pelaajalle varoituksen." example="esim /warn Susse Huono käytös" />
            <Command command="warnings" params="pelaaja" desc="Palauttaa pelaajan varoitukset"/>
            <Command command="unwarn" params="warn_id" desc="Poistaa varoituksen pelaajalta. Varoituksen ID:n saa /warns pelaaja etsimällä" />
            <Command command="mute" params="pelaaja aika syy" example="/mute Susse 4h Spam" />
            <Command command="unmute" params="pelaaja" example="/unmute Susse" />
            <Command command="checkmute" params="pelaaja" desc="Kertoo onko pelaaja hiljennetty" />
            <Command command="history" params="pelaaja" desc="näyttää rangaistushistorian" />
            <Command command="staffhistory" params="pelaaja" desc="näyttää ylläpitäjän antamat rangaistukset" />
            <Command command="ipreport"  desc="Skannaa paikalla olevien ipt alteista" />
            <Command command="lastuuid" params="pelaaja"  desc="Palauttaa pelaajan viimeisen tunnetun UUIDn" />
        </div>
        <h2>Lista muista oikeuksista</h2>
        <ul class="feature-list">
            <li>Kuolemattoman, ja alempien rankkien ominaisuudet</li>
            <li>Ohitat pelaajien /tptogglen</li>
            <li>loputtomasti koteja /sethome</li>
            <li>uusia /spawner tyyppejä
                <ul>
                    <li>Näitä ei kuitenkaan saa käyttää survissa</li>
                </ul>
            </li>
            <li>kaikki taikamaton blockit ja partikkelit</li>
            <li>kaikki partikkelit</li>
            <li>Puukirveen (wandin) käyttö alueen valitsemiseen suojatessa</li>
        </ul>
    </div>
</template>

<script>
import Command from '@/components/Command'

export default {
    name: 'moderator',
    components: {
        Command
    },
    metaInfo: {
      title: 'Moderaattorina'
    }

}
</script>

<style scoped></style>
